import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import pkg from "../../../../package.json"
import { useAppDispatch, useAppSelector } from "../hooks"
import { fetchProfile } from "../network"
import { setErrorAlertMessage } from "../stores/NetworkStore"
import Login from "./component/auth/login"
// import DiscordButton from "./component/buttons/discord-button"
import GithubButton from "./component/buttons/github-button"
import PolicyButton from "./component/buttons/policy-button"
import TermsButton from "./component/buttons/terms-button"
import { Modal } from "./component/modal/modal"
import ServersList from "./component/servers/servers-list"
import "./auth.css"
import ChooseServer from "./component/auth/choose-server"
import Wiki from "./component/wiki/wiki"
import "./auth.css"

export default function Auth() {
  const { t } = useTranslation()
  const isSupposedlyMobile =
    navigator.maxTouchPoints > 0 &&
    window.matchMedia("(orientation: portrait)").matches
  const [modal, setModal] = React.useState<string | null>(null)
  const [shouldRefreshProfile, setShouldRefreshProfile] = React.useState(false)
  const dispatch = useAppDispatch()
  const networkError = useAppSelector((state) => state.network.error)
  const uid = useAppSelector((state) => state.network.uid)
  const discordUrl = process.env.DISCORD_SERVER
  // console.log(this.props.match.params) 
  // const params = useParams(); // 这里的 params 对象将包含路由参数
  const params = new URLSearchParams(window.location.search);
  const giteeCode = params.get("code");
  // ?code=35e49a8814ceabff626a&state=casdoor
  const state = params.get("state");

  // console.log("giteeCode", giteeCode)


  React.useEffect(() => {
    if (!shouldRefreshProfile || !uid) {
      return
    }

    fetchProfile(true)
      .catch((error) => {
        dispatch(
          setErrorAlertMessage(
            error instanceof Error ? error.message : "Unable to refresh profile"
          )
        )
      })
      .finally(() => {
        setShouldRefreshProfile(false)
      })
  }, [dispatch, shouldRefreshProfile, uid])

  return (
    <div className="auth-page">
      {isSupposedlyMobile && (
        <p className="mobile-warning">{t("auth.mobile_warning")}</p>
      )}
      <img className="logo" src="assets/ui/pokemon_autochess_final.svg" />
      <header>
        <h1>{t("auth.pokemon_auto_chess")}</h1>
        <div className="disclaimer">
          <p>{t("auth.nintendo_warning")}</p>
        </div>
      </header>
      <main>
        <ChooseServer />
        <Login giteeCode={giteeCode} state={state}/>
      </main>
      <div className="media">
        {/* <DiscordButton url={discordUrl} /> */}
        <GithubButton />
        <PolicyButton />
        <TermsButton />
        <button className="bubbly blue" onClick={() => setModal("wiki")}>
          <img width={32} height={32} src={`assets/ui/wiki.svg`} />
          {t("wiki.title")}
        </button>
        {/* <button className="bubbly pink" onClick={() => setModal("servers")}>
          <img width={32} height={32} src={`assets/ui/players.svg`} />
          {t("community_servers")}
        </button> */}
        <span onClick={()=>{dispatch(setErrorAlertMessage("当前版本"+pkg.version))}}>V{pkg.version}</span>
        <p>
          {t("auth.made_for_fans")}
          <br />
          {t("auth.non_profit")} / {t("auth.open_source")}
          <br />
          {t("auth.copyright")}
        </p>
      </div>
      <Modal
        onClose={() => setModal(null)}
        show={modal === "wiki"}
        className="wiki-modal"
        header={t("wiki.title")}
      >
        <Wiki inGame={false} />
      </Modal>
      <Modal
        onClose={() => setModal(null)}
        show={modal === "servers"}
        className="servers-modal"
        header={t("servers_list.title")}
      >
        <ServersList />
      </Modal>
      <Modal
        show={networkError != null}
        onClose={() => {
          dispatch(setErrorAlertMessage(null))
        }}
        className="is-dark basic-modal-body"
        body={<p style={{ padding: "1em" }}>{networkError}</p>}
      />
    </div>
  )
}
